import * as React from 'react';

import classNames from 'classnames';

interface IFieldBodyProps {
	className?: string;
}

export default class FieldBody extends React.Component<IFieldBodyProps, {}> {
	public render() {
		const { className } = this.props;

		const classes = classNames('field-body', className ? className : '');

		return <div className={classes}>{this.props.children}</div>;
	}
}
